import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  Box,
  Modal,
  Paper,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

const EditSubCategory = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [mainCategory, setMainCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [description, setDescription] = useState('');

  const navigate = useNavigate();
  const { subCategoryId } = useParams();

  // Static data for pre-fill and dropdown
  const staticSubCategoryData = [
    { subCategoryId: 1, mainCategory: 'Electronics', subCategory: 'Smartphones', description: 'Mobile phones and accessories' },
    { subCategoryId: 2, mainCategory: 'Electronics', subCategory: 'Laptops', description: 'Laptops and notebooks' },
    { subCategoryId: 3, mainCategory: 'Clothing', subCategory: 'Men', description: 'Clothing for men' },
    { subCategoryId: 4, mainCategory: 'Clothing', subCategory: 'Women', description: 'Clothing for women' },
    { subCategoryId: 5, mainCategory: 'Books', subCategory: 'Fiction', description: 'Fiction books' },
    { subCategoryId: 6, mainCategory: 'Books', subCategory: 'Non-Fiction', description: 'Non-fiction books' },
  ];

  const staticMainCategoryData = [
    { mainCategoryId: 1, mainCategory: 'Electronics' },
    { mainCategoryId: 2, mainCategory: 'Clothing' },
    { mainCategoryId: 3, mainCategory: 'Books' },
    { mainCategoryId: 4, mainCategory: 'Home & Kitchen' },
    { mainCategoryId: 5, mainCategory: 'Sports' },
    { mainCategoryId: 6, mainCategory: 'Toys' },
  ];

  useEffect(() => {
    // Simulate fetching data for the subcategory to edit
    const subCategoryToEdit = staticSubCategoryData.find(data => data.subCategoryId === parseInt(subCategoryId));
    if (subCategoryToEdit) {
      setMainCategory(subCategoryToEdit.mainCategory);
      setSubCategory(subCategoryToEdit.subCategory);
      setDescription(subCategoryToEdit.description);
    }
  }, [subCategoryId]);

  const handleSave = (e) => {
    e.preventDefault();
    if (mainCategory && subCategory && description) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Sub Category
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="main-category-label">Main Category</InputLabel>
            <Select
              labelId="main-category-label"
              id="main-category"
              value={mainCategory}
              label="Main Category"
              onChange={(e) => setMainCategory(e.target.value)}
            >
              {staticMainCategoryData.map((category) => (
                <MenuItem key={category.mainCategoryId} value={category.mainCategory}>
                  {category.mainCategory}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Sub Category"
            variant="outlined"
            fullWidth
            value={subCategory}
            onChange={(e) => setSubCategory(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Description"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Button
            variant="contained"
            onClick={handleSave}
            sx={{
              mr: 2,
              backgroundColor: '#127498ff',
              '&:hover': { backgroundColor: '#116280ff' }
            }}
          >
            UPDATE
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Sub Category Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Sub Category Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditSubCategory;
